import React from 'react'
import { Modal, ModalBody, ModalHeader, Collapse, Form, Input, FormGroup, Label, FormText } from 'reactstrap'
import { getItem, constants as LocalStorageConstants ,setItem } from '../../localStorage/localStorageManager'
import { FaAngleDown, FaAngleRight } from 'react-icons/fa'
import { insertUsert } from '../../service/userService'

export default class UserEmailRequest extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            Email: '',
            collapse: false,
            shouldRequest: !getItem(LocalStorageConstants.LOCAL_STORAGE_USER) // local storage check
        }
    }

    handleChange = (e) => {
        const target = e.target
        this.setState({ [target.name]: target.value })
    }

    collapseText = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({ collapse: !this.state.collapse })
    }

    onSubmit = (e) => {
        e.preventDefault()
        e.stopPropagation()
        insertUsert({Email : this.state.Email})
            .catch(err =>{
                console.log(err);
            })
            .finally(() => {
                setItem(LocalStorageConstants.LOCAL_STORAGE_USER, { Email : this.state.Email }); // Local storage email (persisted)
                this.setState({shouldRequest: false});
            })
    }

    render() {
        return (
            <Modal className="user-request-modal" isOpen={this.state.shouldRequest}>
                <ModalHeader className="custom-modal-header">
                    Please, tell us who you are
                </ModalHeader>
                <ModalBody>
                    <Form className="user-request-form" onSubmit={this.onSubmit}>
                        <FormGroup>
                            <Label for="Email">Email*</Label>
                            <Input required type="email" name="Email" id="Email" onChange={this.handleChange} />
                            <FormText color="muted">
                                *We require your email for commercial communications, sending of newsletters purposes.
                                Please, refer to the right text below.
                             </FormText>
                        </FormGroup>
                        <Input className="custom-button" type="submit" value="Send" />
                    </Form>
                    <div className="collapser">
                        <div className="col-1">
                            {this.state.collapse ?
                                <FaAngleDown className="icon clickable" onClick={this.collapseText} /> :
                                <FaAngleRight className="icon clickable" onClick={this.collapseText} />}
                        </div>
                        <div className="col-10 text-center">
                            <h5><b>Data Protection</b></h5>
                        </div>
                    </div>

                    <Collapse isOpen={this.state.collapse} className="right-text">
                        <p>
                            We collect and process your personal data in a correct and transparent way, in conformity with the provisions of the General Data Protection Regulation (UE 2016/679) and the Belgian law of the 30th of July 2018 “relative à la protection des personnes physiques à l'égard des traitements de données à caractère personnel”
                       </p>
                        <h5 className="title">DATA COLLECTION</h5>
                        <p>
                            By communicating your data, these could be collected for statistical purpose. This concerns your e-mail address, your IP address, your geographical zone of consultation, the day and time of consultation as well as the pages accessed.
                            <b>PRAYON</b> is in no way responsible for erroneous or fraudulent data which could be communicated by the beneficiary.
                        </p>
                        <h5 className="title">PROCESSING OF PERSONAL DATA</h5>
                        <p>
                            <b>PRAYON</b> processes your personal data as follows:
                        Record in <b>PRAYON</b>’s database :
                        </p>
                        <ul>
                                <li>- Data processed: E-mail address</li>
                                <li> - Purpose: commercial communications, sending of newsletters</li>
                                <li>- Legal Base: Consent</li>
                                <li>- Data retention duration: until consent withdrawal</li>
                                <li>- Data recipient: <b>PRAYON + NTSS</b></li>
                            </ul>
                            <p>
                                Any e-mail or any other kind of message can also be retained by <b>PRAYON</b>. It can happen that extra personal data, linked to the concerned situation, are being asked. These are used to answer questions and requests and to supplement the profile.
                                These data can be used and processed by <b>PRAYON</b> for relationship management with its visitors, clients and contacts, for operations regularity check and preventing abuses and irregularities.
                            
                        </p>
                        <h5 className="title">RIGHTS OF THE DATA SUBJECT</h5>
                        <p>
                            As provided for by GDPR (Art. 15 to 23), anybody subjected to data processing can, by proving its identity, exercise a series of rights:
                            </p>
                            <ul>
                                <li>-	Obtain, at no cost, a copy of its personal data processed by <b>PRAYON</b> and, where appropriate, any information available on their purpose, origin and destination;</li>
                                <li>                            -	Obtain, at no cost, the rectification of any incorrect personal data and request the completion of any incomplete personal data;</li>
                                <li>
                                    -	Obtain, under conditions provided for by the regulation and at no cost, the withdrawal of its personal data;</li>
                                <li> -	Obtain, under conditions provided for by the regulation and at no cost, the limitation in the processing of its personal data;</li>
                                <li>-	Obtain, at no cost, its personal data (which have been provided to <b>PRAYON</b>) portability, that is receiving, at no cost, data in a commonly used structured format, under the condition that the processing is based on consent or on a contract and that it is performed with automatized processes;</li>
                                <li>-	Oppose, under conditions provided for by the regulation and at no cost, for particular circumstance, to its personal data processing</li>
                                <li>                            -	Withdraw, where appropriate and at no cost, its consent to its personal data processing</li>
                                <li>-	Lodge a complaint with the data protection Authority (<a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer">https://www.autoriteprotectiondonnees.be</a>, contact@apd-gba.be).</li>
                            </ul>
                    </Collapse>
                </ModalBody>
            </Modal>
        )
    }
}